<template>
  <div id="page-business" class="page">
    <header class="header">商务合作</header>
    <p class="subtitle">Business cooperation</p>
    <p class="tags">颠覆    重构    共赢</p>
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-sales-agent.png" />
            <div class="marks">
              <header>销售代理</header>
              <p>Sales Agent</p>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-joint-operation.png" />
            <div class="marks">
              <header>联合运营</header>
              <p>Joint operation</p>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-financial-leasing.png" />
            <div class="marks">
              <header>金融租赁</header>
              <p>Financial leasing</p>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-consultation.png" />
            <div class="marks">
              <header>购买咨询</header>
              <p>Consultation</p>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="row">
        <p class="col-sm"><span class="tel">400-837-6686</span></p>
        <p class="col-sm"><span class="email">bd@entropy.biz</span></p>
      </div>-->
      <div class="row">
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-strategy.png" />
            <div class="marks">
              <header>战略合作</header>
              <p>Strategy</p>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-business.png" />
            <div class="marks">
              <header>商务合作</header>
              <p>Business</p>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="plate">
            <img src="/static/business-media-cooperation.png" />
            <div class="marks">
              <header>媒体合作</header>
              <p>Media cooperation</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <p class="col-sm"><span class="email">sungy@entropy.biz</span></p>
        <p class="col-sm"><span class="email">bd@entropy.biz</span></p>
        <p class="col-sm"><span class="email">bd@entropy.biz</span></p>
      </div>
      <div class="row">
        <div class="col-sm plate">
            <img src="/static/business-all.png" />
        </div>
      </div>
      <!--<div class="row">
        <p class="col-sm"><span class="email">guojy@entropy.biz</span></p>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'business',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#page-business {
  background-color: #fff;
  .header {
    margin-top: 60px;
    font-size: 32px;
    color: #333333;
  }
  .subtitle {
    font-size: 14px;
    color: #888888;
  }
  .tags {
    color: #333333;
    font-size: 24px;
  }
  .plate {
    position: relative;
    margin-top: 30px;
    img {
      width: 100%;
      vertical-align: top;
    }

    .marks {
      position: absolute;
      width: 120px;
      padding-top: 20px;
      bottom: 0;
      right: 0;
      background-color: rgba(1, 146, 248, 0.9);
      color: #ffffff;
      font-size: 12px;

      header {
        font-size: 16px;
      }
    }
  }
  .tel, .email {
    position: relative;
    padding-left: 60px;
  }
  .tel:before, .email:before  {
    position: absolute;
    content: '';
    top: 50%;
    margin-top: -20px;
    left: 0;
    width: 40px;
    height: 40px;
  }
  .tel:before {
    background-image: url(../assets/icon-tel.png);
  }
  .email:before {
    background-image: url(../assets/icon-email.png);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Business.vue